import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { QuizContext } from "../../App";

const TableLibrary = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <>
      <Table
        striped hover
        variant={theme}
        style={{
          border: theme === "dark"
            ? "1px solid black"
            : "1px solid #dadada",
        }}
      >
        <thead>
          <tr>
            <th style={{ fontWeight: "500" }}>Категория</th>
            <th style={{ fontWeight: "500" }}>Квизы</th>
          </tr>
        </thead>
        
        <tbody>
          {quizContext.state.catRU.map((el, i) => (
            <tr key={i}>
              <td
                style={{
                  cursor: "pointer",
                  textAlign: "left",
                  width: "75%"
                }}
              >
                <Link
                  to={`/category/${el.id}`}
                  style={{ textDecoration: "none" }}
                >
                  <button className={`${theme}-link-btn`}
                    onClick={() => quizContext.dispatch({
                      type: "openCatQuizzes", el
                    })}
                  >
                    {el.catname_ru}
                  </button>
                </Link>
              </td>

              <td
                style={{
                  cursor: "context-menu",
                  textAlign: "center",
                  fontWeight: "500"
                }}
              >
                {el.num_of_quizzes}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

export default TableLibrary